<template>
    <div v-loading="allLoading">

        <div style="height: 45px;
        line-height: 45px;
        font-size: 22px;
        background-color: rgb(247 244 244);;
        padding-left: 10px;
        font-weight: 600;">
            {{ match ? match.MatchName : '' }}
            <span style="margin-left: 10px;font-size: 12px;text-decoration: underline;cursor: pointer;"
                @click="choiceMatchDialogVisible = true">重新选择</span>
        </div>


        <div class="content" style="display: flex;">
            <div style="width: 15%;height: 75vh;overflow: hidden;overflow-y: auto;" class="config-list">
                <div style="margin: 30px 0;">
                    <el-button size="small" icon="el-icon-plus" @click.stop="showEditConfigDialog(null)">添加</el-button>
                    <el-button size="small" type="primary" icon="el-icon-search" v-if="match"
                        @click.stop="openUnitScoreDetailDialog()">单位得分明细</el-button>
                </div>
                <div v-for="(config, index) in teamConfig" class="config-item"
                    :class="choiceConfigId && config.ConfigId == choiceConfigId ? 'choicePro' : ''"
                    @click.stop="choiceConfig(config)">
                    {{ config.GroupName }}
                    <i class="el-icon-edit" style="margin: 0 10px;" @click.stop="showEditConfigDialog(config)"></i>
                    <i class="el-icon-delete" style="color: red;" @click.stop="delConfigDialog(config)"></i>
                </div>
            </div>
            <div style="width: 75%;" class="details">
                <div style="margin: 30px 0;">
                    <el-button icon="el-icon-download" size="small" @click.stop="exportTeamScore()">导出</el-button>

                </div>
                <div>
                    <el-table :data="matchTeamItems" max-height="600" size="small" stripe row-key="UserId" border="">
                        <el-table-column label="名次" prop="Ranking" width="80px" align="center">
                            <template slot-scope="scope">
                                {{ scope.row.Rank == 0 ? '' : scope.row.Rank }}
                            </template>
                        </el-table-column>
                        <el-table-column label="团队名称" align="center">
                            <template slot-scope="scope">
                                {{ scope.row.TeamName }}
                            </template>
                        </el-table-column>
                        <el-table-column label="团队简称" align="center">
                            <template slot-scope="scope">
                                {{ scope.row.TempSimpleName }}
                            </template>
                        </el-table-column>
                        <el-table-column label="成绩" prop="TotalPoints" width="150" align="center"></el-table-column>

                        <el-table-column label="备注" prop="Remarks" align="center" width="300">
                            <template slot-scope="scope">
                                <el-input v-model="scope.row.Remark" size="mini" style="width: 250px;">
                                    <el-button slot="append" size="small"
                                        @click="submitEditTeamItem(scope.row)">提交</el-button></el-input>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div style="margin-top: 10px" v-if="false && this.editProjectContestantUsers.length > 0 && isShowDetail">
                    <el-select v-model="rankingOrderType" size="small">
                        <el-option :value="0" label="根据成绩倒序"></el-option>
                        <el-option :value="1" label="根据成绩正序"></el-option>
                    </el-select>
                    <el-select v-model="rankingOrderNum" size="small">
                        <el-option :value="10" label="录取前10名" />
                        <el-option :value="8" label="录取前8名" />
                        <el-option :value="6" label="录取前6名" />
                        <el-option :value="12" label="录取前12名" />
                        <el-option :value="16" label="录取前16名" />
                        <el-option :value="24" label="录取前24名" />
                        <el-option :value="3" label="录取前3名" />
                        <el-option :value="4" label="录取前4名" />
                        <el-option :value="5" label="录取前5名" />
                    </el-select>
                    <el-button size="small" @click="handlerRanking">成绩排行</el-button>
                    <el-button size="small" @click="sysDistributePoint">系统派分</el-button>
                    <el-button type="primary" size="small" @click="submitEdit">保存数据</el-button>
                    <el-button type="primary" size="small" @click="exportProjectScore">导出成绩</el-button>
                </div>
                <div style="margin: 20px 0;" v-if="false">
                    <el-button type="primary" size="small" @click="showTeamRankDialog">团队排行</el-button>
                    <el-button type="primary" size="small" @click="showSetDistributePointDialog">设置派分规则</el-button>
                </div>

            </div>
        </div>

        <el-dialog title="设置派分规则" :visible.sync="distributePointDialogVisible" :close-on-press-escape="false"
            :show-close="false" width="800px">

            <div>
                <el-form style="width: 400px;margin:  0 auto;" label-width="80px">
                    <el-form-item v-for="(item, index) in editDistributePointRuleForm" :label="'名次' + (index + 1)">
                        <el-input-number size="small" v-model="item.point" :min="0"></el-input-number>
                        <el-button v-if="index != 0" size="small"
                            @click="editDistributePointRuleForm.splice(index, 1)">删除</el-button>
                    </el-form-item>
                    <el-form-item>
                        <el-button @click="addDistributePointRuleItem" size="small">添加</el-button>
                    </el-form-item>
                </el-form>
            </div>

            <span slot="footer" class="dialog-footer">



                <el-button type="primary" size="small" @click="submitDistributePoint">确定</el-button>
                <el-button size="small" @click="distributePointDialogVisible = false">取消</el-button>
            </span>
        </el-dialog>

        <el-dialog title="团队配置" :visible.sync="editConfigDialogVisible" :close-on-press-escape="false"
            :show-close="false" width="800px">

            <div style="width: 70%;margin: 0 auto;">
                <el-form :model="editConfigForm" label-width="100px"
                    v-if="match && match.MatchGroups && match.MatchGroups.length > 0">

                    <el-form-item label="分组">
                        <div v-if="match.MatchGroups.length > 0">
                            <el-checkbox-group v-model="editConfigForm.GroupIdArr">
                                <el-checkbox v-for="g in match.MatchGroups" :key="g.GroupId" :label="g.GroupId">
                                    【{{ g.IsSuper == 1 ? '超级组' : '普通组' }}】 {{ g.GroupName }}
                                </el-checkbox>
                            </el-checkbox-group>
                        </div>
                        <div v-else>
                            没有可用的分组数据
                        </div>
                    </el-form-item>
                    <el-form-item label="名次数量">
                        <el-input-number v-model="editConfigForm.RankCount"></el-input-number>
                    </el-form-item>
                </el-form>
                <div v-else>
                    正在加载分组数据...
                </div>
            </div>

            <span slot="footer" class="dialog-footer">
                <el-button type="primary" size="small" @click="submitEditConfig">提交</el-button>
                <el-button size="small" @click="editConfigDialogVisible = false">取消</el-button>
            </span>
        </el-dialog>

        <el-dialog title="选择赛事" :visible.sync="choiceMatchDialogVisible" :close-on-press-escape="false"
            :show-close="false" width="400px">

            <div style="text-align: center;">
                <el-select clearable filterable remote reserve-keyword placeholder="请输入关键词" size="small"
                    :remote-method="remoteMethod" v-model="matchId">
                    <el-option v-for="item in matchOptions" :label="item.MatchName" :value="item.MatchId">
                    </el-option>
                </el-select>
            </div>

            <span slot="footer" class="dialog-footer">
                <el-button type="primary" size="small" @click="confirmChoiceMatch">确定</el-button>
            </span>
        </el-dialog>

        <el-dialog title="单位得分明细(按ESC关闭)" :visible.sync="unitScoreDetailsDialogVisible" :close-on-press-escape="true"
            :show-close="false" :fullscreen="true" >
            <el-input v-model="unitScoreSearch.unitName" placeholder="请输入单位名称" clearable size="small" style="width: 300px;"></el-input>
            <el-button type="primary" size="small" @click="selectUnitScoreDetails()">查询</el-button>
            <el-button type="" size="small" @click="exportUnitScoreDetails()">导出</el-button>
            <div class="table-wrapper" style="margin-top: 20px;">
                <el-table :data="unitScoreDetailTableData" :border="true" size="small" :max-height="650"
                    element-loading-text="数据加载中..." style="width: 100%; min-width: 500px;">
                    <!-- 动态渲染所有列: 第一列为固定单位列，后续为动态项目列 -->
                    <template >
                        <el-table-column v-for="col in unitScoreDetailTableColumns" :key="col.prop" :prop="col.prop" :label="col.label" :width="col.width"
                            :min-width="col.minWidth" :fixed="col.fixed"
                            :align="col.align || (col.prop === 'unit' ? 'left' : 'center')"
                            :header-align="col.headerAlign || 'center'" show-overflow-tooltip>
                            <!-- 自定义单元格内容：针对项目列，如果值为 '-' 进行视觉优化；单位列正常显示 -->
                            <template slot-scope="scope">
                                <span v-if="col.prop === 'unit'">{{ scope.row.unit }}</span>
                                <span v-else :class="{ 'empty-cell': scope.row[col.prop] === '-' }">
                                    {{ scope.row[col.prop] !== undefined && scope.row[col.prop] !== null ?
                                    scope.row[col.prop] : '-' }}
                                </span>
                            </template>
                        </el-table-column>
                    </template>
                </el-table>
                <!-- 无数据提示 -->
                <div v-if="(!unitScoreDetailTableData || unitScoreDetailTableData.length === 0)"
                    style="text-align: center; padding: 40px 0; color: #909399;">
                    <i class="el-icon-document" style="font-size: 48px;"></i>
                    <p style="margin-top: 12px;">暂无数据，请点击刷新或检查接口返回</p>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import MatchService from '@/request-server/request-services/match-services.js';
import SystemService from '@/request-server/request-services/system-services.js';

import Common from '@/utils/utils-common.js';
import Url from '../../../request-server/request-url';
import utilsCommon from '../../../utils/utils-common';
export default {
    data() {
        return {
            allLoading: false,
            matchId: '',
            routerMatchId: '',
            match: null,
            matchOptions: [],
            allMatchs: [],
            choiceMatchDialogVisible: false,
            matchWholeSchedule: [],
            activeNames: [],
            project: null,
            editProjectContestantUsers: [{
            }],
            rankingOrderType: 0,
            rankingOrderNum: 8,
            isShowDetail: false,
            choicePro: '',
            distributePointRule: [],
            editDistributePointRuleForm: [],
            editDistributePointRuleFormRules: {},
            distributePointDialogVisible: false,
            showTeamRankDialogVisible: false,
            teamConfig: [],
            choiceConfigId: '',
            editConfigDialogVisible: false,
            editConfigForm: {
                ConfigId: '',
                MatchId: '',
                GroupName: '',
                GroupIds: '',
                RankCount: 8,
                GroupIdArr: []
            },
            matchTeamItems: [],
            unitScoreDetailsDialogVisible: false,
            unitScoreSearch: {
                matchId: '',
                unitName: '',
            },
            unitScoreDetailTableColumns: [],
            unitScoreDetailTableColumnsInfo: [],
            unitScoreDetailTableData: [],
            unitScoreDetail: []
        }
    },
    computed: {
        // 动态项目列的数量 (除去固定单位列)
        dynamicColumnsCount() {
            return this.unitScoreDetailTableColumns.length > 0 ? this.unitScoreDetailTableColumns.length - 1 : 0;
        }
    },
    watch: {
        '$route'(to, from) {
            this.getAllMatchs();
            this.initData();
        }
    },
    created() {
        this.getAllMatchs();
        this.initData();
        this.initDistributePointRule();
    },
    methods: {
        initDistributePointRule() {
            SystemService.getDistributePointRule().then(res => {
                if (res.code == 0 && res.data != null) this.distributePointRule = JSON.parse(res.data)
            })
        },
        initData() {
            let id = this.$route.params.id;
            if (id) {
                this.choiceMatchDialogVisible = false;
                this.routeMatchId = id;
                this.$store.commit('matchIdCookie', id);

                // 加载团队配置
                MatchService.selectMatchTeamConfigs({ matchId: this.routeMatchId }).then(res => {
                    if (res.code == 0) {
                        this.teamConfig = res.data;
                    }
                });

                // 始终刷新match数据，确保MatchGroups是最新的
                this.allLoading = true; // 显示加载状态
                MatchService.getMatchDetail({ matchId: this.routeMatchId }).then(res => {
                    if (res.code == 0) {
                        this.match = res.data;
                        console.log('加载Match数据:', this.match);
                    }
                    this.allLoading = false; // 隐藏加载状态
                }).catch(() => {
                    this.allLoading = false; // 出错时也隐藏加载状态
                });
            } else {
                //弹框选择赛事
                //获取开始中的赛事
                if (this.$store.state.matchIdCookie) {
                    this.$router.replace('/mainpage/match-team-score/' + this.$store.state.matchIdCookie);
                } else {
                    this.choiceMatchDialogVisible = true;
                }
            }
        },
        confirmChoiceMatch() {
            if (this.matchId != '' && this.matchId != this.routeMatchId) {
                this.$store.commit('matchIdCookie', this.matchId)
                this.$router.replace('/mainpage/match-team-score/' + this.matchId);
            }
            this.choiceMatchDialogVisible = false;
        },
        remoteMethod(query) {
            if (query !== '') {
                this.matchOptions = this.allMatchs.filter(item => {
                    return item.MatchName.indexOf(query) > -1
                })
            } else {
                this.matchOptions = this.allMatchs
            }

        },
        getAllMatchs() {
            MatchService.selectMatchListByName({ matchName: '', signupStatus: '', matchStatus: '' }).then(res => {
                if (res.code == 0) {
                    this.allMatchs = res.data;
                    this.matchOptions = this.allMatchs;
                }
            })
        },
        choiceConfig(config) {
            this.choiceConfigId = config.ConfigId;
            this.selectMatchTeamItems(config.ConfigId);
        },
        exportTeamScore() {
            if (this.choiceConfigId == '') return;
            MatchService.exportTeamScore({ configId: this.choiceConfigId }).then(res => {
                if (res.code == 0) {
                    this.$message.success('导出成功');
                    location.href = Url.getDownloadBaseUrl() + '/exportfiles/' + res.data;
                }
            })
        },
        submitEditTeamItem(item) {
            MatchService.editMatchTeamItem(item).then(res => {
                if (res.code == 0) this.$message.success(res.data);
            })
        },
        showEditConfigDialog(data) {
            console.log('原始match数据:', this.match);
            // 始终重新加载match详情数据，确保有完整的MatchGroups
            this.allLoading = true;
            MatchService.getMatchDetail({ matchId: this.routeMatchId }).then(res => {
                this.allLoading = false;
                if (res.code == 0) {
                    this.match = res.data;
                    console.log('加载新的Match数据:', this.match);

                    if (!this.match.MatchGroups || this.match.MatchGroups.length === 0) {
                        this.$message.warning('当前赛事没有分组数据，请先添加分组');
                        return;
                    }

                    if (data) {
                        this.editConfigForm = utilsCommon.copyObj(data);
                        // 保持原始类型，不进行转换
                        this.editConfigForm.GroupIdArr = this.editConfigForm.GroupIds.split(',');
                        console.log('编辑配置，选中的分组:', this.editConfigForm.GroupIdArr);
                    } else {
                        this.editConfigForm = {
                            ConfigId: '',
                            MatchId: this.routerMatchId,
                            GroupName: '',
                            GroupIds: '',
                            RankCount: 8,
                            GroupIdArr: []
                        };
                    }

                    this.editConfigDialogVisible = true;
                } else {
                    this.$message.error('获取赛事详情失败');
                }
            }).catch(err => {
                this.allLoading = false;
                this.$message.error('获取赛事详情出错');
            });
        },
        submitEditConfig() {
            if (this.editConfigForm.GroupIdArr.length == 0) {
                this.$message.warning('请选择分组');
                return;
            }


            if (this.editConfigForm.RankCount == '' || this.editConfigForm.RankCount <= 0) {
                this.$message.warning('名次数量必须大于0');
                return;
            }

            // 保持原始类型连接
            this.editConfigForm.GroupIds = this.editConfigForm.GroupIdArr.join(',');
            this.editConfigForm.MatchId = this.match.MatchId;

            console.log('提交的表单数据:', this.editConfigForm);

            MatchService.editMatchTeamConfig(this.editConfigForm).then(res => {
                if (res.code == 0) {
                    this.$message.success(res.data);
                    this.initData();
                    this.editConfigDialogVisible = false;

                    if (this.choiceConfigId != '' && this.editConfigForm.ConfigId == this.choiceConfigId) {
                        this.selectMatchTeamItems(this.choiceConfigId);
                    }
                }
            });
        },
        selectMatchTeamItems(configId) {

            MatchService.selectMatchTeamItems({ configId: configId }).then(res => {
                if (res.code == 0) {
                    this.matchTeamItems = res.data;
                }
            })

        },
        delConfigDialog(config) {
            this.$confirm(
                "是否确认要删除该配置",
                "提示",
                {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                }
            )
                .then(() => {
                    MatchService.deleteMatchTeamConfig({ configId: config.ConfigId }).then((res) => {
                        if (res.code == 0) {
                            this.$message.success(res.data);
                            this.initData();
                        }
                    });
                })
                .catch(() => { });
        },

        sysDistributePoint() {
            if (!this.distributePointRule) {
                this.$message.warning('请先设置派分规则');
                return;
            }
            if (this.editProjectContestantUsers.length == 0) return;

            this.distributePointRule.forEach(element => {
                this.editProjectContestantUsers.filter(a => a.Ranking == element.index).forEach(u => {
                    u.TotalPoints = element.point;
                })
            });

        },
        showTeamRankDialog() {
            this.showTeamRankDialogVisible = true;
        },

        showSetDistributePointDialog() {
            this.editDistributePointRuleForm = utilsCommon.copyObj(this.distributePointRule);
            if (this.editDistributePointRuleForm.length == 0) {
                this.addDistributePointRuleItem();
            }
            this.distributePointDialogVisible = true;
        },
        addDistributePointRuleItem() {
            this.editDistributePointRuleForm.push({ index: this.editDistributePointRuleForm.length + 1, point: 0 })
        },
        submitDistributePoint() {
            let isok = true;
            this.editDistributePointRuleForm.forEach((element, index) => {
                element.index = index + 1;
                if (element.point == '' || element.point <= 0) {
                    this.$message.warning('名词' + (element.index) + '值无效，请核实');
                    isok = false;
                    return;
                }
            });

            if (isok) {
                SystemService.setDistributePointRule({ rule: JSON.stringify(this.editDistributePointRuleForm) }).then(res => {
                    if (res.code == 0) {
                        this.distributePointRule = utilsCommon.copyObj(this.editDistributePointRuleForm);
                        this.distributePointDialogVisible = false;
                    }
                })
            }

        },
        handlerRanking() {
            if (this.editProjectContestantUsers.length == 0) return;
            if (this.rankingOrderType == 1) {
                this.editProjectContestantUsers = this.editProjectContestantUsers.sort((a, b) => a.Score - b.Score);
            } else {
                this.editProjectContestantUsers = this.editProjectContestantUsers.sort((a, b) => b.Score - a.Score);
            }

            this.editProjectContestantUsers.forEach(user => {
                user.Ranking = '';
            })
            let lastRank = 0;
            for (let index = 1; index <= this.rankingOrderNum; index++) {
                if (index == 1) {
                    if (this.editProjectContestantUsers[index - 1].Score > 0) {
                        this.editProjectContestantUsers[index - 1].Ranking = index;
                    }

                } else if (this.editProjectContestantUsers[index - 1].Score < 1 || this.editProjectContestantUsers[index - 1].Score == '') {

                }
                else if (this.editProjectContestantUsers.length >= index) {
                    if (this.editProjectContestantUsers[index - 2].Score == this.editProjectContestantUsers[index - 1].Score) {
                        this.editProjectContestantUsers[index - 1].Ranking = this.editProjectContestantUsers[index - 2].Ranking
                    } else {
                        this.editProjectContestantUsers[index - 1].Ranking = index;
                    }
                }
                lastRank = index;
            }

            //获取最后一名的分数
            let user = this.editProjectContestantUsers.find(a => a.Ranking == lastRank);
            this.editProjectContestantUsers.filter(a => a.Score == user.Score).forEach(u => {
                u.Ranking = lastRank;
            })

        },
        submitEdit() {
            let data = Common.copyObj(this.editProjectContestantUsers);
            data.forEach((element, index) => {

                if (element.ComeOnGroup == '' || element.ComeOnNum == '') {
                    this.$message.error('第' + (index + 1) + '行序号无效，请核对');
                    return;
                }


                element.IsWaiver = element.IsWaiverChecked ? 1 : 0;
                element.IsFoul = element.IsFoulChecked ? 1 : 0;
                element.IsWithdrawMidway = element.IsWithdrawMidwayChecked ? 1 : 0;
                element.IsTest = element.IsTestChecked ? 1 : 0;
                element.IsRecordBreaking = element.IsRecordBreakingChecked ? 1 : 0;
                element.Ranking = element.Ranking <= 0 || element.Ranking == '' ? 0 : element.Ranking;
                element.Score = element.Score <= 0 || element.Score == '' ? 0 : element.Score;
                element.TotalPoints = element.TotalPoints <= 0 || element.TotalPoints == '' ? 0 : element.TotalPoints;
            });

            MatchService.setContestantUserScore(data).then(res => {
                if (res.code == 0) {
                    this.$message.success(res.data);
                    this.initData();
                }
            })

        },
        toMatchRank() {
            var newWindow = window.open(window.origin + '#/match-rank/' + this.routeMatchId, '_blank');
            if (newWindow) {
                // 尝试在新窗口加载后将其置为全屏
                newWindow.onload = function () {
                    if (newWindow.document.fullscreenEnabled) {
                        newWindow.document.documentElement.requestFullscreen().catch(err => {
                            console.error(`Error attempting to enable full-screen mode: ${err.message} (${err.name})`);
                        });
                    }
                };
            }
        },
        toMatchScoreView() {
            var newWindow = window.open(window.origin + '#/match-score-view/' + this.routeMatchId, '_blank');
            if (newWindow) {
                // 尝试在新窗口加载后将其置为全屏
                newWindow.onload = function () {
                    if (newWindow.document.fullscreenEnabled) {
                        newWindow.document.documentElement.requestFullscreen().catch(err => {
                            console.error(`Error attempting to enable full-screen mode: ${err.message} (${err.name})`);
                        });
                    }
                };
            }
        },
        exportProjectScore() {

            let data = utilsCommon.copyObj(this.project);
            let users = utilsCommon.copyObj(this.editProjectContestantUsers);
            users.forEach(element => {
                element.Ranking = element.Ranking == '' ? 0 : element.Ranking;
            });
            data.Regions = [];
            data.ContestantUserGroups = [{
                ContestantUsers: users
            }]
            MatchService.exportProjectScore(data).then(res => {
                if (res.code == 0) {
                    this.$message.success('导出成功');
                    location.href = Url.getDownloadBaseUrl() + '/exportfiles/' + res.data;
                }
            })

        },
        openUnitScoreDetailDialog() {
            this.selectUnitScoreDetails();
            this.unitScoreDetailsDialogVisible = true;
            this.unitScoreSearch.unitName = '';
        },
        selectUnitScoreDetails() {
            this.unitScoreSearch.matchId = this.routeMatchId;
            this.unitScoreSearch.unitName = this.unitScoreSearch.unitName || '';
            MatchService.selectUnitScoreDetails(this.unitScoreSearch).then(res => {
                if (res.code == 0) {
                    this.unitScoreDetail = res.data;
                    this.unitScoreDetailsDialogVisible = true;
                    this.processBackendData(this.unitScoreDetail);
                }
            })
        },
        processBackendData(backendData) {
            // 1. 标准化为数组 (处理单对象或数组)
            let unitList = [];
            if (Array.isArray(backendData)) {
                unitList = backendData.filter(item => item && typeof item === 'object' && item.UnitName && item.ProjectScores);
            } else if (backendData && typeof backendData === 'object' && backendData.UnitName && backendData.ProjectScores) {
                // 符合题目的单对象格式: {UnitName:'单位1', ProjectScores:[...]}
                unitList = [backendData];
            } else {
                console.warn("后端数据格式不符合预期，应为包含 UnitName 和 ProjectScores 的对象或数组", backendData);
                this.unitScoreDetailTableData = [];
                this.unitScoreDetailTableColumns = [];
                this.columnsInfo = false;
                return;
            }

            if (!unitList.length) {
                this.unitScoreDetailTableData = [];
                this.unitScoreDetailTableColumns = [];
                this.unitScoreDetailTableColumnsInfo = false;
                return;
            }

            // 2. 收集所有出现的项目名称 (保持相对顺序: 按照遍历每个单位的 Pros 顺序去重，保留首次出现)
            const projectNamesSet = new Set();
            const orderedProjectNames = [];
            for (let unitItem of unitList) {
                const projectScores = unitItem.ProjectScores || [];
                for (let pro of projectScores) {
                    const JoinProName = pro.JoinProName;
                    if (JoinProName && !projectNamesSet.has(JoinProName)) {
                        projectNamesSet.add(JoinProName);
                        orderedProjectNames.push(JoinProName);
                    }
                }
            }

            // 3. 构建动态列配置 (除单位列以外的项目列)
            const dynamicColumns = orderedProjectNames.map(JoinProName => ({
                prop: JoinProName,                // 直接用项目名称作为属性名
                label: JoinProName,              // 表头显示项目名称
                minWidth: 110,
                align: 'center',
                headerAlign: 'center'
                // 可根据需要增加宽度或固定列效果
            }));

            // 固定单位列 (第一列)
            const unitColumn = {
                prop: 'unit',
                label: '单位',
                width: 150,
                fixed: 'left',
                align: 'left',
                headerAlign: 'center'
            };

            // 最终列配置: 单位列 + 动态项目列
            this.unitScoreDetailTableColumns = [unitColumn, ...dynamicColumns];

            // 4. 构建表格行数据: 每一个单位对应一行
            const rows = [];
            for (let unitItem of unitList) {
                const unitName = unitItem.UnitName;
                const projectScores = unitItem.ProjectScores || [];
                // 创建一个行对象，基础属性 unit
                const row = { unit: unitName };
                // 为每个动态项目列填充成绩或默认 '-'
                for (let JoinProName of orderedProjectNames) {
                    // 在当前单位的项目Scores中查找匹配的项目
                    const matchedPro = projectScores.find(p => p.JoinProName === JoinProName);
                    if (matchedPro && (matchedPro.Score !== undefined && matchedPro.Score !== null)) {
                        // 成绩有效 (支持0分)
                        row[JoinProName] = matchedPro.Score;
                    } else {
                        // 没有对应项目成绩，显示占位符 '—' 提升可读性
                        row[JoinProName] = '-'; 
                    }
                }
                rows.push(row);
            }

            this.unitScoreDetailTableData = rows;
            this.unitScoreDetailTableColumnsInfo = true;

            // 额外日志输出（开发调试用，可忽略）
            console.log("动态表头构建完成，项目列数:", orderedProjectNames.length, "单位数量:", rows.length);
        },

        exportUnitScoreDetails() {
            this.unitScoreSearch.matchId = this.routeMatchId;
             MatchService.exportUnitScoreDetails(this.unitScoreSearch).then(res => {
                if (res.code == 0) {
                    this.$message.success('导出成功');
                    location.href = Url.getDownloadBaseUrl() + '/exportfiles/' + res.data;
                }
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.config-list {
    height: 100%;
    overflow: hidden;
    overflow-y: auto;
}

.config-item {
    min-height: 30px;
    line-height: 30px;
    border-bottom: 1px solid #e3e3e3;
    cursor: pointer;
    padding: 0px 10px;
    box-sizing: border-box;
}

.pro-item:hover {
    background-color: #FAFAFA;
}

.pro-item span {
    color: #666;
}

.choicePro {
    background-color: #c1e0ff;
    font-weight: 600;
}

.details {
    padding: 0px 30px;
    box-sizing: border-box;
}

.pro-name {
    font-size: 22px;
    font-weight: 600;
    height: 40px;
    line-height: 40px;
}
</style>
